/** Body copy for the card. Spells out that an answer is scored as given and
 * that a redo happens from Results after the whole interview — candidates
 * otherwise read "keep chatting" as "you can answer this one again". */
export function nextStepBody(
  variant: 'next' | 'final',
  {
    coachingEnabled,
    canRetake,
    isVoiceMode,
    isGuest = false,
  }: { coachingEnabled: boolean; canRetake: boolean; isVoiceMode: boolean; isGuest?: boolean }
): string {
  // Voice names the mic: testers didn't realise it opens a follow-up chat.
  const voiceFollowUp = 'Click the mic below to ask a follow-up question';
  if (variant === 'final') {
    // A guest never lands on Results themselves — the sitting goes to the
    // agency that issued the code — so the card can't point them there.
    if (isGuest) {
      return coachingEnabled
        ? `${isVoiceMode ? voiceFollowUp : 'You can keep chatting for more feedback'}, or finish up — your results go straight to the agency that sent you the code.`
        : 'Finish up — your results go straight to the agency that sent you the code.';
    }
    const retake = canRetake ? ' From there, Try Again lets you redo the questions you pick.' : '';
    return coachingEnabled
      ? `${isVoiceMode ? voiceFollowUp : 'You can keep chatting for more feedback'}, or head to your results.${retake}`
      : `Head to Results for your scores and feedback.${retake}`;
  }
  if (!coachingEnabled) {
    if (isGuest) return 'Your answer is saved. Continue to the next question.';
    return canRetake
      ? 'Your answer is saved. Scores, feedback and Try Again unlock in Results after the last question.'
      : 'Your answer is saved. Scores and feedback appear in Results after the last question.';
  }
  const redo = canRetake ? ' To redo a question, finish the interview, then use Try Again in Results.' : '';
  return `${isVoiceMode ? voiceFollowUp : 'Keep chatting to learn more'}, or continue. Your answer is already scored.${redo}`;
}
